module.exports = __webpack_public_path__ + "static/media/javascript.4f4315df.svg";